class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    // CBS: auto-load on desktop only; on mobile (< 750px) customers tap "Show more" so the footer stays reachable
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    if (this.dataset.trigger == 'infinite' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 600px 0px'});
      this.onMediaChange = this.updateMode.bind(this);
      if (this.mobileQuery.addEventListener) {
        this.mobileQuery.addEventListener('change', this.onMediaChange);
      } else if (this.mobileQuery.addListener) {
        this.mobileQuery.addListener(this.onMediaChange);
      }
      this.updateMode();
    }
  }

  updateMode() {
    if (!this.observer) return;
    if (this.mobileQuery.matches) {
      this.observer.unobserve(this);
    } else {
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.onMediaChange) {
      if (this.mobileQuery.removeEventListener) {
        this.mobileQuery.removeEventListener('change', this.onMediaChange);
      } else if (this.mobileQuery.removeListener) {
        this.mobileQuery.removeListener(this.onMediaChange);
      }
    }
  }

  onClickHandler(event) {
    if (event && event.target.closest('a')) return;
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.remove('infinite-scroll--error');
    this.classList.add('loading');
    this.classList.add('disabled');
    this.setAttribute('aria-busy', 'true');

    InfiniteScroll.renderSectionFromFetch(this.dataset.url, this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting || this.mobileQuery.matches) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSectionId() {
    const grid = document.getElementById('product-grid');
    return grid ? grid.dataset.id : null;
  }

  static buildUrl(url) {
    const sectionId = InfiniteScroll.getSectionId();
    if (!sectionId) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
  }

  static renderSectionFromFetch(url, element) {
    fetch(InfiniteScroll.buildUrl(url))
      .then(response => {
        if (!response.ok) throw new Error('Infinite scroll request failed: ' + response.status);
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (!html.getElementById('product-grid')) throw new Error('Infinite scroll: product grid not found in response');
        InfiniteScroll.renderProductGridContainer(html);
        InfiniteScroll.renderPagination(html);
      })
      .catch((e) => {
        console.error(e);
        if (element && element.isConnected) {
          element.classList.remove('loading', 'disabled');
          element.classList.add('infinite-scroll--error');
          element.removeAttribute('aria-busy');
        }
      });
  }

  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (!container) return;
    const pagination = html.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = html.getElementById('product-grid');
    container.insertAdjacentHTML('beforeend', products.innerHTML);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
